import React, {useEffect, useState} from "react";
import { useNavigate, useParams } from "react-router-dom";
import BlurredComponent from "../common/BlurredComponent_all";
const host = window?.location?.hostname ?? 'localhost'
const AuthHandler = () => {
    const { token } = useParams(); // Получаем токен из URL
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) return;

        const sendToken = async () => {
            try {
                const response = await fetch(`https://${host}/auth_token`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ token }),
                });

                if (!response.ok) throw new Error("Ошибка запроса");

                const data = await response.json();
                if (data.token) {
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('id', data?.id);
                    window.location.href = "/";
                }
            } catch (error) {
                console.error("Ошибка авторизации:", error);
                navigate("LoginForm");
            }
        };
        sendToken();
    }, [token, navigate]);

    return <BlurredComponent isBlurred message={'Идет авторизация'}>
    </BlurredComponent>;
};

export default AuthHandler;
